var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[(_vm.userId)?_c('wtr-profile',{attrs:{"userId":Number(_vm.userId),"isSuperAdmin":_vm.isSuperAdmin},on:{"on-load":_vm.loaded,"on-update":_vm.updated,"on-cancel":_vm.cancelled}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }